import { useContext } from 'react';

import { TimeseriesInteractionsContext } from '../context/TimeseriesInteractions.context.js';

export const useChartInteractions = () =>
  useContext(TimeseriesInteractionsContext);
